import { render, staticRenderFns } from "./CompositeAlert.vue?vue&type=template&id=0a3e5684&"
import script from "./CompositeAlert.vue?vue&type=script&lang=ts&"
export * from "./CompositeAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports